<template>
  <div class="d-flex justify-content-center">
    <div class="skywards-tiers d-flex flex-column flex-md-row align-items-start justify-content-center mt-2 mb-4">
      <div class="input-wrap mr-md-3 mb-1 mb-md-0">
        <input type="radio" name="skywards-tiers" id="skywards-blue" @input="onSelectTier($event)">
        <label for="skywards-blue">Emirates Skywards Blue</label>
      </div>
      <div class="input-wrap mr-md-3 mb-1 mb-md-0">
        <input type="radio" name="skywards-tiers" id="skywards-silver" @input="onSelectTier($event)">
        <label for="skywards-silver">Emirates Skywards Silver</label>
      </div>
      <div class="input-wrap">
        <input type="radio" name="skywards-tiers" id="skywards-gold-plat" @input="onSelectTier($event)" checked>
        <label for="skywards-gold-plat">Emirates Skywards Gold or Platinum</label>
      </div>
    </div>
  </div>

  <div class="table-wrap" ref="tableWrapEl">
    <table ref="tableEl">
      <thead>
        <tr>
          <th v-for="(heading, index) in top_row_headings" :class="index === 0 ? 'left-col-heading' : ''" :key="index">{{ heading }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tier, index_1) in selectedTier.rows" :key="index_1">
          <td v-for="(row, index_2) in tier.content" :class="index_2 === 0 ? 'left-col-heading' : ''" :key="index_2">
            <div v-if="row.copy">
              <img :src="row.img_src" alt="" class="mb-1" :style="`width: ${row.img_w}px;`">
              <p v-html="row.copy"></p>
            </div>
            <div v-else-if="row.isChecked" class="dot">
              <img src="/images/icon_dot.png" alt="">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="swipe-wrapper bg-bonvoy-white d-flex justify-content-end d-md-none py-2 px-3" ref="swipeWrapperEl">
    <div class="d-flex align-items-center">
      <img src="/images/icon_caret-down.png" alt="" class="caret caret-left" ref="scrollLeftIcon">
      <p class="label mx-2">Swipe</p>
      <img src="/images/icon_caret-down.png" alt="" class="caret caret-right" ref="scrollRightIcon">
    </div>
  </div>

</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import { icon_w } from '../../utilities';

const selectedTier = ref('');
const tableEl = ref(null);
const tableWrapEl = ref(null);
const scrollLeftIcon = ref(null);
const scrollRightIcon = ref(null);
const swipeWrapperEl = ref(null);

function scrollPosition() {
  const scrollLeft = tableWrapEl.value.scrollLeft;
  const scrollWidth = tableWrapEl.value.scrollWidth;
  const offsetWidth = tableWrapEl.value.offsetWidth;

  // console.log(scrollLeft, scrollWidth, offsetWidth);

  if (scrollLeft === 0) {
    scrollLeftIcon.value.classList.add('hide');
  } else {
    scrollLeftIcon.value.classList.remove('hide');
  }

  if (scrollLeft >= (scrollWidth - offsetWidth)) {
    scrollRightIcon.value.classList.add('hide');
    swipeWrapperEl.value.classList.add('mr-2');
  } else {
    scrollRightIcon.value.classList.remove('hide');
    swipeWrapperEl.value.classList.remove('mr-2');
  }
}

onMounted(() => {
  selectedTier.value = content[2];

  nextTick(() => {
    scrollPosition();
  });

  tableWrapEl.value.addEventListener('scroll', () => {
    scrollPosition();
  });
});

function onSelectTier(e) {
  if (e.target.id === 'skywards-blue') {
    selectedTier.value = content[0];
  } else if (e.target.id === 'skywards-silver') {
    selectedTier.value = content[1];
  } else if (e.target.id === 'skywards-gold-plat') {
    selectedTier.value = content[2];
  }
}

const top_row_headings = [
  'Benefits',
  'Marriott Bonvoy Member',
  'Marriott Bonvoy Silver Elite',
  'Marriott Bonvoy Gold Elite',
  'Marriott Bonvoy Platinum, Titanium, or Ambassador Elite',
];

const benefit_row_1 = {
  img_src: '/images/icon_star.png',
  img_w: icon_w.star,
  copy: '3 points per US$1 spent on Emirates flights (on top of Skywards Miles)',
};

const benefit_row_2 = {
  img_src: '/images/icon_airplane-outline.png',
  img_w: icon_w.airplane,
  copy: '1 Skywards Mile per US$1 spent on hotel stays (on top of Marriott Bonvoy points)',
};

const benefit_row_3 = {
  img_src: '/images/icon_clock.png',
  img_w: icon_w.clock,
  copy: 'Elite in-airport benefits, including priority check-in and priority boarding',
};

const benefit_row_4 = {
  img_src: '/images/icon_calendar-arrow.png',
  img_w: icon_w.calendar,
  copy: '4pm Late Checkout for Emirates Platinum members and 2pm Late Checkout for Emirates Gold members, access to Elite check-in, and complimentary in-room <span class="no-wrap">Wi-Fi</span> on hotel stays',
};

const content = [
  { // blue
    rows: [
      { // row 1
        content: [
          benefit_row_1,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
      { // row 2
        content: [
          benefit_row_2,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
        ],
      },
      { // row 3
        content: [
          benefit_row_3,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
        ],
      },
      { // row 4
        content: [
          benefit_row_4,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
        ],
      },
    ],
  },
  { // silver
    rows: [
      { // row 1
        content: [
          benefit_row_1,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
      { // row 2
        content: [
          benefit_row_2,
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
      { // row 3
        content: [
          benefit_row_3,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
        ],
      },
      { // row 4
        content: [
          benefit_row_4,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
        ],
      },
    ],
  },
  { // gold / plat
    rows: [
      { // row 1
        content: [
          benefit_row_1,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
      { // row 2
        content: [
          benefit_row_2,
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
      { // row 3
        content: [
          benefit_row_3,
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: false, },
          { isChecked: true, },
        ],
      },
      { // row 4
        content: [
          benefit_row_4,
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
          { isChecked: true, },
        ],
      },
    ],
  },
];
</script>

<style lang="scss">
@import '../../../styles/variables';

#app {
  .swipe-wrapper {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: 0 0 6px $gray;
    margin-left: 1px;
  }
  .caret {
    width: 13px;
    height: 8px;
  }
  .caret-left {
    transform: rotate(90deg);
  }
  .caret-right {
    transform: rotate(-90deg);
  }
}
</style>
